import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Box, Button, Typography } from '@mui/material'
import OrbitSession from 'hooks/useCookies'

export default function OrderSuccess() {
  return (
    <Box
      height='100vh'
      sx={{
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          width: '80%'
        }}
      >
        <Box sx={{ width: '60%', textAlign: 'center', marginBottom: '48px' }}>
          <Typography variant='h4' sx={{ marginBottom: '48px' }}>
            Thank you for placing an order with Circles.Life Orbit
          </Typography>
          <Typography variant='h6'>
            Your order is currently being processed. A confirmation email will
            be sent to the provided email.
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '60%'
          }}
        >
          {OrbitSession.get('_id') !== undefined ? (
            <Button
              id='backToHomepageButton'
              aria-label='return to homepage'
              variant='contained'
              component={RouterLink}
              to='/'
              sx={{
                width: '90%'
              }}
            >
              Back to homepage
            </Button>
          ) : (
            <Button
              variant='contained'
              component={RouterLink}
              to='/login'
              sx={{
                width: '100%'
              }}
            >
              Log in
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  )
}
